module.exports = __webpack_public_path__ + "static/media/far_Logo.8ac19b88.jpg";